import { AfterViewInit, Component } from '@angular/core';
import { SnackService } from '../../service/snack.service';

@Component({
  selector: 'app-allcomponents',
  standalone: false,

  templateUrl: './allcomponents.component.html',
  styleUrl: './allcomponents.component.scss'
})
export class AllcomponentsComponent implements AfterViewInit {
  constructor(
    private snack: SnackService
  ) { }

  ngAfterViewInit(): void {
    this.snack.info({headline:"Info", text:"Welcome to the All Components section!"});
  }
}
